module.exports = __webpack_public_path__ + "img/mask.6cceeb0c.png";